import React from "react";

import IndeterminateCheckbox from "components/uiComponents/IndeterminateCheckbox";

export const getRowSelectionColumn = () => ({
  id: "select",
  header: ({ table }) => {
    const isSomeRowsSelected = table.getIsSomeRowsSelected();
    const isAllRowsSelected = table.getIsAllRowsSelected();

    const getAllRowsSelectedHandler = () => {
      const handler = table.getToggleAllRowsSelectedHandler();

      return table.options.enabledInverseAllSelection &&
        isSomeRowsSelected &&
        !isAllRowsSelected
        ? () => table.resetRowSelection(false)
        : handler;
    };

    return table.options.enableMultiRowSelection ? (
      <IndeterminateCheckbox
        indeterminate={isSomeRowsSelected}
        checked={isAllRowsSelected}
        handleChange={getAllRowsSelectedHandler()}
      />
    ) : null;
  },
  cell: ({ row }) => {
    return (
      <IndeterminateCheckbox
        disabled={!row.getCanSelect()}
        checked={row.getIsSelected()}
        handleChange={row.getToggleSelectedHandler()}
      />
    )
  },
  size: 44,
  minSize: 44,
  maxSize: 44,
  enableResizing: false,
});
